import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Inicio from './Inicio';
import Institucional from './paginas/Institucional/Institucional';
import Livros from './paginas/Ensino/Livros';
import Jornal from './paginas/Jornal/Jornal';
import Contato from './paginas/Contato/Contato';
import Professores from './paginas/NossosProfessores/Equipe';
import EnsinoFundamental1 from './paginas/Ensino/Fundamental/1/EnsinoFundamental1';
import EnsinoFundamental2 from './paginas/Ensino/Fundamental/2/EnsinoFundamental2';
import EnsinoMedio from './paginas/Ensino/Medio/EnsinoMedio';
import Materiais from './paginas/Materiais/Materiais';
import Matricula from './paginas/Landing/Matricula';
import Lead from './paginas/Lead/Lead'

import WhatsAppButton from './componentes/js/Whatsapp';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <link rel="icon" href="assets/images/logo/colegio-lider.ico" media="(prefers-color-scheme: light)" />
    <link rel="icon" href="assets/images/logo/colegio-lider-2.ico" media="(prefers-color-scheme: dark)" />
    <WhatsAppButton zapURL={'https://api.whatsapp.com/send?phone=5562998271550&text=Bom%20dia!'}/>
    <Router>
      <Routes>
        <Route path='/inicio' element={<Inicio />} />
        <Route path='/institucional' element={<Institucional />} />
        <Route path='/jornal' element={<Jornal />} />
        <Route path='/contato' element={<Contato />} />
        <Route path='/livros' element={<Livros />} />
        <Route path='/confirmacao' element={<Lead />} />
        <Route path='/matricule-se' element={<Matricula />} />
        <Route path='/ensino-fundamental-1' element={<EnsinoFundamental1 />} />
        <Route path='/ensino-fundamental-2' element={<EnsinoFundamental2 />} />
        <Route path='/ensino-medio' element={<EnsinoMedio />} />
        <Route path='/materiais' element={<Materiais />} />
        <Route path='/nossa-equipe' element={<Professores />} />
        <Route path='/' element={<Navigate to='/inicio' />} />
        <Route path='*' element={<Navigate to='/inicio' replace />} />
      </Routes>
    </Router>
  </React.StrictMode>
);